module.exports = __webpack_public_path__ + "media/images/services-f0842138366ecaf93c76a5248e69f366.jpg";